<div
  class="layout-nav"
  [class.layout-nav--panel-open]="panelPinned"
  [class.layout-nav--flyout-open]="flyoutOpen"
  (mouseenter)="onNavEnter()"
  (mouseleave)="onNavLeave()">
  <div class="layout-nav__rail">
    <app-nav-rail></app-nav-rail>
  </div>

  <!-- Pinned / mobile: inline panel (width animated; stays mounted for fluid expand/collapse) -->
  <div
    class="layout-nav__panel layout-nav__panel--inline"
    [attr.aria-hidden]="panelPinned ? null : 'true'">
    <app-nav-panel></app-nav-panel>
  </div>

  <!-- Collapsed hover: overlay flyout (does not shift main content; stays mounted for fluid open/close) -->
  <div
    class="layout-nav__panel layout-nav__panel--flyout"
    [attr.aria-hidden]="flyoutOpen ? null : 'true'"
    (mouseenter)="onNavEnter()">
    <app-nav-panel></app-nav-panel>
  </div>
</div>
